/** Shared utilities for live-screen views (teacher + school admin). */

export const POLL_INTERVAL = 15_000; // 15 seconds

/** Event-type → emoji map used in browser mockups and tiles. */
export const EVENT_TYPE_ICON: Record<string, string> = {
  page_visit: '🌐',
  search: '🔍',
  typed_content: '⌨️',
  app_usage: '📱',
  download: '⬇️',
  file_access: '📁',
};

/** Human-readable relative timestamp. */
export function timeAgo(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime();
  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  return `${Math.floor(m / 60)}h ago`;
}

/** Full date/time for "Last Seen" labels. */
export function formatLastSeen(dateStr: string): string {
  return new Date(dateStr).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Extract up-to-2-letter initials from a full name. */
export function initials(name: string): string {
  return name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();
}

/** Grid column classes for each grid size. */
export const GRID_COLS: Record<GridSize, string> = {
  large: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
  medium: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4',
  small: 'grid-cols-3 sm:grid-cols-4 lg:grid-cols-6',
};

export type FilterMode = 'all' | 'online' | 'flagged';
export type GridSize = 'large' | 'medium' | 'small';

/** Severity badge colour map used by both roles. */
export const SEVERITY_COLORS: Record<string, string> = {
  critical: 'text-red-500',
  high: 'text-orange-500',
  medium: 'text-amber-500',
  low: 'text-blue-400',
};
